export enum WorkflowValidationResponse {
    Validated = 1,
    Rejected = 2,
    Reassigned = 3,
}
